import React, { useEffect, useState } from "react";
import { getFileIcon } from "../utils/Icon"; 
import { IoIosArrowUp } from "react-icons/io";
import { IoGridOutline } from "react-icons/io5";
import { FaList } from "react-icons/fa";
import { Tuning2 } from "@solar-icons/react";
import useFiles from "../context/FileContext";

const SafeFolder = () => {
   const { files, setFiles, viewType, setViewType, search } = useFiles();
  const [movedItem, setMovedItem] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
      const [showAll, setShowAll] = useState(false);
  useEffect(() => {
    const item = localStorage.getItem("safeFolderItem");
    if (item) {
      setMovedItem(JSON.parse(item));
    }
  }, []);

  // Optional: Handle item click
  const handleItemClick = (item) => {
    console.log("Item clicked:", item);
    // Add your navigation logic or modal open here
  };

  return (
    <div className=" mt-[10%] md:mt-[4%]">
      <div className=" flex justify-between mt-10 md:mt-5">
             <h4 className="text-secondary font-semibold text-xl">Safe Folder</h4>
     
             <div className="flex justify-end gap-3 ">
               <div className=" hidden md:w-10 h-10 border border-gray-300 rounded-md md:flex items-center justify-center hover:bg-gray-100 cursor-pointer">
                 <Tuning2 onClick={() => setShowFilter(!showFilter)} />
               </div>
     
               <div className="flex border border-gray-300  rounded-md overflow-hidden w-fit h-10">
                 <button
                   className={`w-10 h-10 flex items-center justify-center transition duration-200 ${
                     viewType === "list" ? "bg-four text-black" : "text-secondary "
                   }`}
                   onClick={() => {
                     setViewType("list");
                     setIsMenuOpen(false);
                   }}
                 >
                   <FaList />
                 </button>
     
                 <button
                   className={`w-10 h-10 flex items-center justify-center transition duration-200 ${
                     viewType === "grid" ? "bg-four text-black" : "text-secondary "
                   }`}
                   onClick={() => {
                     setViewType("grid");
                     setIsMenuOpen(false);
                   }}
                 >
                   <IoGridOutline />
                 </button>
               </div>
     
               <button
                 className="hidden md:w-[150px] h-10 md:flex items-center justify-center gap-2 border border-gray-300 bg-four text-secondary font-medium text-sm rounded-md hover:opacity-90 transition"
                 onClick={() => setShowAll(!showAll)}
               >
                 <span>View all</span>
                 <IoIosArrowUp
                   fontSize={20}
                   className={`transition-transform duration-300 ${
                     showAll ? "rotate-180" : ""
                   }`}
                 />
               </button>
             </div>
           </div>

      {movedItem ? (
        <div className="border border-gray-300 p-4 rounded-md bg-white shadow-sm w-full max-w-md mt-5">
          <p className="text-sm font-medium mb-2">Moved Item Details:</p>
          
          <div className="w-24 mb-3">
            <img
              className={`w-full rounded-md object-contain transition-all duration-300 ${
                movedItem.isLocked && !movedItem.isDirectory
                  ? "blur-md opacity-50 cursor-not-allowed"
                  : ""
              }`}
              onClick={() => handleItemClick(movedItem)}
              src={getFileIcon(movedItem.name, movedItem.url)}
              alt={movedItem.name}
            />
          </div>

          <p className="text-sm text-gray-700">
            <span className="font-semibold">Name:</span> {movedItem.name}
          </p>
          <p className="text-xs text-gray-500 mt-1">
            <span className="font-semibold">ID:</span> {movedItem._id}
          </p>
        </div>
      ) : (
        <p className="text-gray-500 text-sm">No item moved yet.</p>
      )}
    </div>
  );
};

export default SafeFolder;
